import { Breadcrumbs } from "components/breadcrumbs";
import { useCreate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { IHomepageCouponForm } from "interfaces";
import { HomepageCouponForm } from "./components";

export const CreateHomepageCoupon: React.FC = () => {

  const { mutate, isLoading: isSubmitingSubCategoryForm } = useCreate();
  const navigate = useNavigate();

  const onSubmit = (values: IHomepageCouponForm) => {
    const submitValues = { ...values };
    mutate(
      {
        resource: "mkt/coupon-homepages",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          ...submitValues,
        },
      },
      {
        onSuccess: () => {
          toast.success("Create successfully");
          navigate(`/mkt/homepage-coupon`);
        },
      }
    );
  };

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Homepage coupon" />
      <HomepageCouponForm onSubmit={onSubmit} />
      {isSubmitingSubCategoryForm ? <FullScreenLoading /> : <></>}
    </div>
  );
};
